module.exports = __webpack_public_path__ + "img/brand_domain_illustration_card.a7b33f4b.svg";